import { useCallback, useEffect, useMemo, useState } from 'react'
import { REPOSITORY } from '../../../api/repository/Repository'
import { numberFormat } from '../../../utils/formats/formats'
import { useFoundEmployee } from '../../../utils/hooks/employees/useFoundEmployee'

const useDiscount = ({ sEstado = ['AC'], sBusqueda = '' }) => {
  const [discountData] = useState({})
  const [employeesChanged, setEmployeesChanged] = useState([])
  const filters = useMemo(() => {
    if (sBusqueda.includes('NN')) {
      return {
        sEstado,
        sNombre: sBusqueda,
        sBusqueda: '',
      }
    }
    return { sEstado, sBusqueda }
  }, [sEstado, sBusqueda])
  const {
    allEmployees,
    totalPages,
    page,
    applyFilters,
    handleChangeFilter,
    handleChangePage,
    resetEmployees,
    handleChangeEmployee,
  } = useFoundEmployee(filters, true)

  useEffect(() => {
    setEmployeesChanged(allEmployees)
  }, [allEmployees])

  const discountIsValid = useMemo(
    () =>
      !!employeesChanged.find((item) => numberFormat(item.nMonto, 'number')),
    [employeesChanged],
  )

  const fillTotalBalance = useCallback(
    ({ data }) => {
      handleChangeEmployee((prevState) =>
        prevState.map((item) =>
          item.sEmpleado === data.sEmpleado
            ? { ...item, nMonto: data.sSaldo }
            : item,
        ),
      )
    },
    [allEmployees, handleChangeEmployee],
  )

  const fillAllTotalBalance = useCallback(() => {
    handleChangeEmployee((prevState) =>
      prevState.map((item) => ({ ...item, nMonto: item.sSaldo })),
    )
  }, [handleChangeEmployee])

  const employeesChangedReplace = useCallback((newArray) => {
    setEmployeesChanged(newArray)
  }, [])

  const handleEmployeesChange = useCallback((_, employee) => {
    setEmployeesChanged((prevState) => {
      if (!numberFormat(employee.nMonto, 'number')) {
        return prevState.reduce(
          (acc, el) =>
            el.sEmpleado === employee.sEmpleado
              ? [...acc, { ...el, ...employee }]
              : [...acc, el],
          [],
        )
      }
      const exist = prevState.find(
        (item) => item.sEmpleado === employee.sEmpleado,
      )
      if (exist) {
        return prevState.reduce((acc, el) => {
          if (el.sEmpleado === employee.sEmpleado) {
            return [...acc, { ...el, ...employee }]
          }
          return [...acc, el]
        }, [])
      }
      return [...prevState, employee]
    })
  }, [])

  const resetAmmount = () => {
    const newEmployees = allEmployees.map((item) => ({ ...item, nMonto: '' }))
    resetEmployees(newEmployees)
  }

  const sendDiscount = useCallback(
    async (values) =>
      REPOSITORY.wsEmpresa.discounts.discount({
        ...values,
        cEmpleados: employeesChanged
          .filter((item) => item.nMonto)
          .map((item) => ({
            ...item,
            nMonto: numberFormat(item.nMonto, 'number'),
          })),
      }),
    [employeesChanged, allEmployees],
  )

  const handleChangePageWithReset = (newPage) => {
    setEmployeesChanged([])
    handleChangePage(newPage)
  }
  return {
    employees: allEmployees,
    discountData,
    employeesChanged,
    discountIsValid,
    sendDiscount,
    handleEmployeesChange,
    resetEmployees,
    totalPages,
    page,
    handleChangeFilter,
    handleChangePage: handleChangePageWithReset,
    employeesChangedReplace,
    applyFilters,
    resetAmmount,
    fillTotalBalance,
    fillAllTotalBalance,
  }
}

export default useDiscount
